import { ItemPrice } from '../productPricing/ItemPrice'
import { BuildConfig } from '../config/BuildConfig'
import Decimal from 'decimal.js-light'

export interface SearchApiResponse {
  data: SearchApiProduct[]
}

export interface SearchApiProduct {
  itemNumber: string
  catNo: string
  rrp: number
}

export const isProductApiAvailable = (): boolean => {
  return BuildConfig.brand.productDataApiEndpoint !== null
}

// for some reason "export async function ..." is causing weird ts errors
export const searchForProducts = async function searchForProducts(itemNos: string[]): Promise<ItemPrice[]> {
  const apiEndpoint = BuildConfig.brand.productDataApiEndpoint

  if (!apiEndpoint) {
    return []
  }

  const rawResponse = await fetch(`${apiEndpoint}?itemNumbers=${itemNos.join(',')}`)

  // artificial delay to test loading states
  if (process.env.NODE_ENV === 'development') {
    await new Promise(r => setTimeout(r, 500))
  }

  const response = await rawResponse.json() as SearchApiResponse
  return transformResponse(response)
}

function tryParsePrice(price: unknown): Decimal | null {
  if (typeof price !== 'number' || price <= 0) {
    return null
  }

  try {
    return new Decimal(price)
  } catch (e) {
    return null
  }
}

function transformResponse(response: SearchApiResponse): ItemPrice[] {
  return response.data
    .map(item => ({ itemNo: item.itemNumber, retailPrice: tryParsePrice(item.rrp) }))
}